import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { Input } from '@components/core-ui/form-elements/Input';
import { Textarea } from '@components/core-ui/form-elements/Textarea';
import { isContactSalesFormIncomplete } from './helpers/isContactSalesFormIncomplete';
import { TProps } from './types/TProps';
import { Wrapper } from './styles/Wrapper';

export const ContactSalesForm = ({ formState, setFormState, isSubmitting, onSubmit }: TProps) => {
  const submitDisabled = isSubmitting || isContactSalesFormIncomplete(formState);

  return (
    <Wrapper>
      <div className="form-section">
        <h4>Let’s Find the Right Solution for You</h4>
        <p>
          Tell us a little about your needs and we’ll help you select the right mix of product and services for you or
          your team.
        </p>
      </div>

      <div className="form-section">
        <h4>Personal details</h4>
        <div className="line flex-col md:flex-row md:!flex-nowrap">
          <Input
            onChange={(event) => {
              setFormState({
                ...formState,
                details: {
                  ...formState.details,
                  name: event.target.value,
                },
              });
            }}
            label="First name"
            value={formState.details.name}
            required={true}
          />
          <Input
            onChange={(event) => {
              setFormState({
                ...formState,
                details: {
                  ...formState.details,
                  surname: event.target.value,
                },
              });
            }}
            label="Last name"
            value={formState.details.surname}
            required={true}
          />
        </div>
        <div className="line flex-col md:flex-row md:!flex-nowrap">
          <Input
            onChange={(event) => {
              setFormState({
                ...formState,
                details: {
                  ...formState.details,
                  email: event.target.value,
                },
              });
            }}
            label="Email address"
            value={formState.details.email}
            required={true}
          />
          <Input
            onChange={(event) => {
              setFormState({
                ...formState,
                details: {
                  ...formState.details,
                  phone: event.target.value,
                },
              });
            }}
            label="Phone number"
            value={formState.details.phone}
            required={true}
          />
        </div>
      </div>

      <div className="form-section">
        <h4>Type of work *</h4>
        <div className="line flex-col md:flex-row md:!flex-nowrap">
          <Button
            className={`!w-full ${formState.typeOfWork === 'independent' ? 'check-button active' : 'check-button'}`}
            onClick={() => {
              setFormState({
                ...formState,
                typeOfWork: 'independent',
                companyName: '',
              });
            }}
          >
            I am independent contractor
          </Button>
          <Button
            className={`!w-full ${formState.typeOfWork === 'agency' ? 'check-button active' : 'check-button'}`}
            onClick={() => {
              setFormState({
                ...formState,
                typeOfWork: 'agency',
                companyName: '',
              });
            }}
          >
            I work for an Agency / Company
          </Button>
          <Button
            className={`!w-full md:max-w-[25%] ${formState.typeOfWork === 'CourtRoom' ? 'check-button active' : 'check-button'}`}
            onClick={() => {
              setFormState({
                ...formState,
                typeOfWork: 'CourtRoom',
                companyName: '',
              });
            }}
          >
            CourtRoom
          </Button>
        </div>
        {formState.typeOfWork === 'agency' ? (
          <div className="line">
            <Input
              label="Agency / Company name (Optional)"
              value={formState.companyName}
              required={false}
              onChange={(event) => {
                setFormState({
                  ...formState,
                  companyName: event.target.value,
                });
              }}
            />
          </div>
        ) : null}
      </div>

      <div className="form-section">
        <h4 className="mb-[5px]">Your role *</h4>
        <div className="line">
          <Button
            className={`${formState.role === 'owner' ? 'check-button active' : 'check-button'}`}
            onClick={() => {
              if (formState.role === 'owner') {
                setFormState({
                  ...formState,
                  role: '',
                });
              } else {
                setFormState({
                  ...formState,
                  role: 'owner',
                });
              }
            }}
          >
            Owner / Operations
          </Button>
          <Button
            className={`${formState.role === 'reporter' ? 'check-button active' : 'check-button'}`}
            onClick={() => {
              if (formState.role === 'reporter') {
                setFormState({
                  ...formState,
                  role: '',
                });
              } else {
                setFormState({
                  ...formState,
                  role: 'reporter',
                });
              }
            }}
          >
            Reporter
          </Button>
          <Button
            className={`${formState.role === 'transcriber' ? 'check-button active' : 'check-button'}`}
            onClick={() => {
              if (formState.role === 'transcriber') {
                setFormState({
                  ...formState,
                  role: '',
                });
              } else {
                setFormState({
                  ...formState,
                  role: 'transcriber',
                });
              }
            }}
          >
            Transcriber / Editor
          </Button>
          <Button
            className={`${formState.role === 'court-admin' ? 'check-button active' : 'check-button'}`}
            onClick={() => {
              if (formState.role === 'court-admin') {
                setFormState({
                  ...formState,
                  role: '',
                });
              } else {
                setFormState({
                  ...formState,
                  role: 'court-admin',
                });
              }
            }}
          >
            Court admin
          </Button>
          <Button
            className={`${formState.role === 'everything' ? 'check-button active' : 'check-button'}`}
            onClick={() => {
              if (formState.role === 'everything') {
                setFormState({
                  ...formState,
                  role: '',
                });
              } else {
                setFormState({
                  ...formState,
                  role: 'everything',
                });
              }
            }}
          >
            I do everything
          </Button>
        </div>
      </div>

      <div className="form-section">
        <div>
          <h4 className="mb-[5px]">What tools do you use today? *</h4>
          <h5>Select all that apply</h5>
        </div>
        <div className="line">
          <Button
            className={`${formState.tools.asd ? 'check-button active' : 'check-button'}`}
            onClick={() => {
              setFormState({
                ...formState,
                tools: {
                  ...formState.tools,
                  asd: !formState.tools.asd,
                },
              });
            }}
          >
            AutoScript Desktop
          </Button>
          <Button
            className={`${formState.tools.asone ? 'check-button active' : 'check-button'}`}
            onClick={() => {
              setFormState({
                ...formState,
                tools: {
                  ...formState.tools,
                  asone: !formState.tools.asone,
                },
              });
            }}
          >
            AutoScriptOne
          </Button>
          <Button
            className={`${formState.tools.attorneyView ? 'check-button active' : 'check-button'}`}
            onClick={() => {
              setFormState({
                ...formState,
                tools: {
                  ...formState.tools,
                  attorneyView: !formState.tools.attorneyView,
                },
              });
            }}
          >
            AttorneyView
          </Button>
          <Button
            className={`${formState.tools.cat ? 'check-button active' : 'check-button'}`}
            onClick={() => {
              setFormState({
                ...formState,
                tools: {
                  ...formState.tools,
                  cat: !formState.tools.cat,
                },
              });
            }}
          >
            Case CATalyst
          </Button>
          <Button
            className={`${formState.tools.eclipse ? 'check-button active' : 'check-button'}`}
            onClick={() => {
              setFormState({
                ...formState,
                tools: {
                  ...formState.tools,
                  eclipse: !formState.tools.eclipse,
                },
              });
            }}
          >
            Eclipse
          </Button>
          <Button
            className={`${formState.tools.maxscribe ? 'check-button active' : 'check-button'}`}
            onClick={() => {
              setFormState({
                ...formState,
                tools: {
                  ...formState.tools,
                  maxscribe: !formState.tools.maxscribe,
                },
              });
            }}
          >
            MAXScribe
          </Button>
          <Button
            className={`${formState.tools.word ? 'check-button active' : 'check-button'}`}
            onClick={() => {
              setFormState({
                ...formState,
                tools: {
                  ...formState.tools,
                  word: !formState.tools.word,
                },
              });
            }}
          >
            Word
          </Button>
          <Button
            className={`${formState.tools.other ? 'check-button active' : 'check-button'}`}
            onClick={() => {
              setFormState({
                ...formState,
                tools: {
                  ...formState.tools,
                  other: !formState.tools.other,
                  otherName: '',
                },
              });
            }}
          >
            Other (Specify)
          </Button>
        </div>
        {formState.tools.other ? (
          <div className="line">
            <Input
              onChange={(event) => {
                setFormState({
                  ...formState,
                  tools: {
                    ...formState.tools,
                    otherName: event.target.value,
                  },
                });
              }}
              label="Type software names, dividing them with commas (Optional)"
              value={formState.tools.otherName}
              required={false}
            />
          </div>
        ) : null}
      </div>

      <div className="form-section">
        <h4>Do you have an AutoScript account? *</h4>
        <div className="line">
          <Button
            className={`${formState.autoScriptAccount ? 'check-button active' : 'check-button'}`}
            onClick={() => {
              setFormState({
                ...formState,
                autoScriptAccount: true,
              });
            }}
          >
            Yes
          </Button>
          <Button
            className={`${!formState.autoScriptAccount ? 'check-button active' : 'check-button'}`}
            onClick={() => {
              setFormState({
                ...formState,
                autoScriptAccount: false,
              });
            }}
          >
            No
          </Button>
        </div>
      </div>

      <div className="form-section">
        <h4>Do you outsource your transcription? *</h4>
        <div className="line">
          <Button
            className={`${formState.outsource === 'never' ? 'check-button active' : 'check-button'}`}
            onClick={() => {
              setFormState({
                ...formState,
                outsource: 'never',
                outsourceTo: '',
              });
            }}
          >
            Never
          </Button>
          <Button
            onClick={() => {
              setFormState({
                ...formState,
                outsource: 'sometimes',
                outsourceTo: '',
              });
            }}
            className={`${formState.outsource === 'sometimes' ? 'check-button active' : 'check-button'}`}
          >
            Sometimes
          </Button>
          <Button
            className={`${formState.outsource === 'all' ? 'check-button active' : 'check-button'}`}
            onClick={() => {
              setFormState({
                ...formState,
                outsource: 'all',
                outsourceTo: '',
              });
            }}
          >
            All / Most of the time
          </Button>
        </div>
        {formState.outsource === 'sometimes' || formState.outsource === 'all' ? (
          <div className="line">
            <Input
              label="What company do you outsource to? (Optional)"
              value={formState.outsourceTo}
              required={false}
              onChange={(event) => {
                setFormState({
                  ...formState,
                  outsourceTo: event.target.value,
                });
              }}
            />
          </div>
        ) : null}
      </div>

      <div className="form-section">
        <h4>
          Anything else? <span>(optional)</span>
        </h4>
        <div className="line">
          <Textarea
            value={formState.notes}
            label="What else do you want to share with us?"
            onChange={(event) => {
              setFormState({
                ...formState,
                notes: event.target.value,
              });
            }}
          />
        </div>
      </div>

      <Button onClick={onSubmit} className="primary" disabled={submitDisabled}>
        Submit
      </Button>
    </Wrapper>
  );
};
